<span #span [class]="this.notInline ? 'markdown-inline' : 'is-mark-inline markdown-inline'" [innerHTML]="output"></span>
<!-- {{input}} -->